<template>
  <div class="c-meta-row">
    <div class="c-meta-row__full">
      <slot name="full"></slot>
    </div>
    <div class='flex-split'>
      <div class="c-meta-row__left">
        <slot name="left">
          <inline-list :withBigPadding="true" class="flexlist">
            <li v-if="object.user && showUser" class="u-hide-mobile">
              <profile-card-mini :user="object.user" :showAvatar="showAvatar" />
            </li>
            <li v-if="object.created_time">
              <icon name="clock" />
              {{ ' ' }}
              <time :datetime="$dayjs(timeString).format('YYYY-MM-DD')">{{timeString}}</time>
            </li>
            <li v-if="object.idea_count && showIdeaCount">
              <icon name="lightbulb" :fill="false" />
              {{object.idea_count}}
              <span
                class="u-hide-mobile"
              >{{ '&nbsp;' }}{{object.idea_count == 1 ? ' idea' : ' ideas'}}</span>
            </li>
            <li v-if="object.new && showStatus" class="u-hide-mobile">
              <span class="new-standout">New</span>
            </li>
            <li
              v-if="showStatus && object.end_date && ($dayjs(object.end_date).format('YYYY-MM-DD') <= $dayjs().format('YYYY-MM-DD')) || object.status == 'closed'"
              class="u-hide-mobile"
            >
              <span class="closed-standout">Closed</span>
            </li>
            <li
              v-else-if="showStatus && object.end_date && ($dayjs(object.end_date).format('YYYY-MM-DD') < $dayjs().add(7,'day').format('YYYY-MM-DD'))"
              class="u-hide-mobile"
            >
              <span class="closing-standout">Closing Soon</span>
            </li>
            <li v-if="object.vote_count && showVotes">
              <button class="inline">
                <icon name="thumbsup" :fill="false" />
                
                <span>
                  {{object.vote_count}}
                  <span
                    class="u-hide-mobile"
                  >{{object.vote_count == 1 ? ' vote' : ' votes'}}</span>
                </span>
              </button>
            </li>
            <li v-if="showResponseCount">
              <button class="inline">
                <icon name="comments" :fill="false" class="comment-icon" />
                
                <span>{{object.comment_count}}</span>
              </button>
            </li>
            <li v-if="showStatus && object.status == 'draft'" class="u-hide-mobile">
              <inline-label type="notice">Draft</inline-label>
            </li>
            <li v-if="object.private && showPrivate" class="u-hide-mobile">
              <inline-label type="dark">Private</inline-label>
            </li>
            <li v-if="showPinned && object.pinned" class="u-hide-mobile">
              <icon name="pin" :fill="false" />
              Pinned
            </li>
          </inline-list>
        </slot>
      </div>

      <div class="c-meta-row__right" v-if="showAttachments">
        <slot name="right">
          <div class="c-meta-row__item" v-if="object.files">
            <base-tooltip text="Click to download" v-if="object.files.length === 1">
              <base-button asLink @click="onFileDownload">
                <icon name="attachment" class="icon--attachment" />
                1 attachment
              </base-button>
            </base-tooltip>
            <base-tooltip text="Click to view" v-else>
              <base-button asLink @click="onFilePreview">
                <icon name="attachment" class="icon--attachment" />
                {{object.files.length}} attachments
              </base-button>
            </base-tooltip>
            <div class="c-dropdown--mini" v-if="showFilesToggle">
              <dropdown-action
                v-for="(file,index) in object.files"
                :key="file.id"
                @click="onFileDownload(index)"
              >
                <file-icon :type="file.mime_type.split('/').slice(-1)[0]" />
                {{file.name}}
              </dropdown-action>
            </div>
          </div>
          <div class="c-meta-row__item u-hide-mobile" v-else>
            <icon name="attachment" class="icon--attachment" />
            0 attachments
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { Date, InlineLabel } from "@/components/elements";
import DropdownAction from "./DropdownAction";
import ProfileCardMini from "@/components/contentElements/ProfileCardMini";
import InlineList from "@/components/Lists/InlineList";
import filesApi from "@/api/files";

export default {
  name: "meta-row",

  props: {
    object: Object,
    showUser: {
      type: Boolean,
      default: true
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    showResponseCount: {
      type: Boolean,
      default: true
    },
    showAttachments: {
      type: Boolean,
      default: true
    },
    showPrivate: {
      type: Boolean,
      default: true
    },
    showVotes: {
      type: Boolean,
      default: true
    },
    showIdeaCount: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    showPinned: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onFileDownload(index = 0) {
      const file = this.object.files[index];
      this.$store.dispatch("files/download", file);
    },
    onFilePreview() {
      this.showFilesToggle = !this.showFilesToggle;
    }
  },

  components: {
    Date,
    ProfileCardMini,
    InlineList,
    InlineLabel,
    DropdownAction
  },

  data() {
    return {
      showFilesToggle: false
    };
  },

  computed: {
    timeString() {
      // TODO: Should this be a relative string or just the date?
      return this.$dayjs(this.object.created_time).format("DD / MM / YYYY");
      // const posted = this.$dayjs(this.object.created_time);
      // return this.$dayjs().to(posted);
    }
  }
};
</script>

<style lang="scss">
.c-meta-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: $colour-nhs-dark-grey;
  flex-direction: column;

  padding: 1em 0 0;
  margin-bottom: 1em;

  .flex-split {
    display: inline-flex;
    flex-basis: 100%;
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
  }

  &__left,
  &__right {
    display: inline-flex;
    align-items: center;
    position: relative;
    flex: 2;
  }

  &__right {
    flex: 1;
  }

  &__full {
    display: inline-flex;
    margin-bottom: 10px;
  }

  &__right {
    justify-content: flex-end;
  }

  &__item:not(:first-of-type) {
    margin-left: 1em;
  }

  &__item:not(:first-of-type) {
    margin-left: 1em;
  }

  .flexlist {
    display: flex;

    li {
      display: inline-flex;
      align-items: center;

      svg {
        margin-right: 5px;
      }
    }
  }

  time {
    color: $colour-nhs-dark-grey;
  }
}

.icon {
  &--attachment {
    height: 12px;
  }
}

.new-standout {
  font-weight: bold;
  color: #16a446;
}

.closing-standout {
  font-weight: bold;
  color: $colour-nhs-orange;
}
.closed-standout {
  font-weight: bold;
  color: $colour-nhs-emergency-red;
}

.c-dropdown--mini {
  background: $colour-nhs-white;
  border-radius: 4px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  position: absolute;
  right: 0;
  z-index: 10;
  width: 250px;

  .c-dropdown__action {
    display: block;
    padding: 0 1em;
    height: 54px;
    line-height: 54px;
    color: #425563;
    text-decoration: none;
    cursor: pointer;
    text-align: left;

    svg {
      max-width: 20px;
      max-height: 20px;
      &:first-of-type {
        display: none;
      }
    }
  }
}
</style>

